<template>
    <div class="p-day-one__save">
        <modal-in-the-wild modal-name="save_day_one_fatal">
            <button class="a-button">
                {{!exists ? 'Save as new claim' : 'Update Claim'}}
            </button>
        </modal-in-the-wild>

        <modal name="save_day_one_fatal" no-default-button="true" wide>
            <div class="c-save-as-new-claim" v-if="!showList">
                <h1>Save your assessment</h1>
                <span v-show="!exists">
                    Click the button below to attach this assessment to existing claim
                    or complete the form to save as a new claim
                </span>
                <h2>Claim details</h2>
                <div class="flex-grid a-form-inputs">
                    <div class="flex-grid__item">
                        <control for="claimant_name" label="Claimant Name" v-if="showNames">
                            <input type="text" name="claimant_name" required v-field-control v-model="claimantName">
                            <control-error :show="$error('claimant_name')">
                                The claimant name is required.
                            </control-error>
                        </control>
                        <typeahead
                                :required=true
                                :label="'Claimant Solicitors'"
                                :error-message="'The claimant solicitor is required.'"
                                :value="claimantSolicitors"
                                :type="'claimant_solicitors'"
                                @update="updateClaimantSolicitors"
                        ></typeahead>
                        <control for="claimant_reference" label="Claimant Solicitors Reference">
                            <input type="text" name="claimant_reference" required v-field-control
                                   v-model="claimantReference">
                            <control-error :show="$error('claimant_reference')">
                                The claimant solicitors reference name is required.
                            </control-error>
                        </control>
                    </div>

                    <div class="flex-grid__item flex-grid--space-left">
                        <control for="your_reference" label="Your Reference">
                            <input type="text" name="your_reference" required v-field-control
                                   v-model="yourReference">
                            <control-error :show="$error('your_reference')">
                                Your reference is required
                            </control-error>
                        </control>
                        <typeahead
                                :required=true
                                :label="'Defendant Name'"
                                :error-message="'The defendant name is required.'"
                                :value="defendantName"
                                :type="'defendant'"
                                @update="updateDefendant"
                        ></typeahead>
                        <div v-show="showErrorMessage">
                            All fields are required.
                        </div>
                        <button class="a-button a-button--small a-button--loader-button" @click="doSave"
                                :disabled="!updateValid()"
                                :class="[isSaving ?'a-loader--white':'']">
                            <span :class="[isSaving ? 'a-button--span-hidden' : '']">{{exists ? "Update" : "Save"}}</span>
                        </button>
                        <button class="a-button a-button--small" @click="cancel">Cancel</button>
                        <button class="a-button a-button--small" v-if="exists" @click="routeToClaim">Open as Claim
                        </button>
                        <button class="a-button a-button--small" v-if="exists" @click="openSummaryDocument">Download Day
                            One Summary
                        </button>
                        <button class="a-button a-button--small" v-if="!exists" @click="toggleClaimList">
                            Attach to existing claim
                        </button>
                        <p v-if="!exists">
                            <span class="a-form-inputs--error">Save your claim before you can download the summary.</span>
                        </p>
                    </div>
                </div>
            </div>
            <div class="c-attached-to-existing" v-if="showList">
                <a class="u-float-r u-cursor-pointer" @click="toggleClaimList">
                    Return to save new claim
                </a>
                <claim-table @select="attachToClaim"></claim-table>
            </div>
        </modal>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import Control from "components/form/Control";
    import Modal from 'components/modal/Modal';
    import ModalInTheWild from 'components/modal/ModalInTheWild';
    import ControlError from "components/form/control/Error";
    import FormValidator from 'components/form/validator/mixin';
    import ClaimTable from 'pages/claims-dashboard/components/Table';
    import Typeahead from "components/Typeahead";

    export default {
        name: "day-one-save",
        components: {
            Control,
            ControlError,
            Modal,
            ModalInTheWild,
            ClaimTable,
            Typeahead
        },
        mixins: [
            FormValidator
        ],
        data() {
            return {
                showErrorMessage: false,
                showList: false,
                claim: false,
                isSaving: false
            }
        },
        computed: {
            ...mapGetters('user', [
                'getToken',
            ]),
            ...mapGetters('reserves/dayOneLost', ['isValidForSave', 'exists', 'estateOrDependency', 'claimType']),
            ...mapGetters('user', ['showNames']),
            claimantName: {
                get() {
                    return this.getValue('claimantName');
                },
                set(value) {
                    this.updateValue({key: 'claimantName', value});
                    this.updateValid();
                }
            },
            claimantSolicitors: {
                get() {
                    return this.getValue('claimantSolicitors');
                },
            },
            claimantReference: {
                get() {
                    return this.getValue('claimantReference');
                },
                set(value) {
                    this.updateValue({key: 'claimantReference', value});
                    this.updateValid();
                }
            },
            yourReference: {
                get() {
                    return this.getValue('yourReference');
                },
                set(value) {
                    this.updateValue({key: 'yourReference', value});
                    this.updateValid();
                }
            },
            defendantName: {
                get() {
                    return this.getValue('defendantName');
                },
            },
        },
        methods: {
            ...mapActions('reserves/dayOneLost', [
                'updateValue',
                'save',
                'openAsClaim'
            ]),
            ...mapActions('modal', ['toggle']),
            ...mapActions('claim', ['load']),
            getValue(attr) {
                return this.$store.getters['reserves/dayOneLost/' + attr];
            },
            cancel() {
                this.toggle('save_day_one_lost');
            },
            updateValid() {
                let validForSave = this.$valid() && this.isValidForSave;
                this.showErrorMessage = !validForSave;

                return validForSave;
            },
            doSave() {
                if (this.updateValid()) {
                    this.isSaving = true;

                    this.save().then(() => {
                            this.isSaving = false
                        }
                    );
                }
            },
            routeToClaim() {
                this.openAsClaim()
                    .then(() => {
                        const route = '/lost-years/' + this.getValue('claimId') + '/claimant-details';
                        return this.$router.push(route);
                    });
            },
            toggleClaimList() {
                this.showList = !this.showList;
            },
            attachToClaim(claim) {
                return Promise
                    .all([
                        this.updateValue({key: 'claimantName', value: claim.claimant_name}),
                        this.updateValue({
                            key: 'claimantSolicitors', value: {
                                id: claim.claimant_solicitor_id,
                                name: claim.claimant_solicitor,
                                type: 'claimant_solicitor'
                            }
                        }),
                        this.updateValue({key: 'claimantReference', value: claim.claimant_reference}),
                        this.updateValue({key: 'yourReference', value: claim.your_reference}),
                        this.updateValue({
                            key: 'defendantName', value: {
                                id: claim.defendant_id,
                                name: claim.defendant_name,
                                type: 'defendant'
                            }
                        }),
                    ])
                    .then(() => this.save(claim.id))
                    .then(() => this.claim = claim)
                    .then(() => this.showList = false);
            },
            openSummaryDocument() {
                window.open('/api/v1/day-one-summary/pdf/' + this.getValue('claimId') + '?access_token=' + this.getToken);
            },
            updateClaimantSolicitors(value) {
                this.updateValue({key: 'claimantSolicitors', value});
                this.updateValid();
            },
            updateDefendant(value) {
                this.updateValue({key: 'defendantName', value});
                this.updateValid();
            }
        }
    }
</script>


// WEBPACK FOOTER //
// DayOneSave.vue?1fe978b3